module.exports = __webpack_public_path__ + "img/map_1791458180964_85700.97f3df1f.jpg";